// Status-group map from the api (task 355.10), provided once by the shell (StatusGroupsProvider) and read
// by StatusPill and the list quick filters. Outside the shell (tests, login) the map is empty and every
// consumer falls back to the client map in statusGroups.ts.

import { createContext, useContext } from 'react';
import type { StatusGroup } from './statusGroups';

export type StatusGroupMap = ReadonlyMap<string, StatusGroup>;

export const EMPTY_STATUS_GROUPS: StatusGroupMap = new Map();

export const StatusGroupsContext = createContext<StatusGroupMap>(EMPTY_STATUS_GROUPS);

export function useStatusGroupMap(): StatusGroupMap {
  return useContext(StatusGroupsContext);
}
